import { tr } from "./i18n.js";

/**
 * Fluxurile de proces ale mentenanței — definite O SINGURĂ DATĂ, aici.
 *
 * Aplicația are 24 de secțiuni, iar bara le grupează după FELUL lucrurilor
 * (clienți, resurse, comercial, analize). Gruparea aia răspunde la „unde e
 * ecranul X". Nu răspunde la întrebarea pe care și-o pune un om nou:
 * „de unde plec și unde ajung?"
 *
 * Fișierul ăsta răspunde la a doua. Fiecare flux e un lanț de pași; fiecare pas
 * numește secțiunea în care se lucrează și — mai important — CE trece mai
 * departe. Legătura dintre două module nu e o săgeată desenată frumos: e o
 * coloană, o tranzacție sau o regulă din bază, iar `duce` o spune pe scurt.
 *
 * Se folosește în trei locuri, ca să nu poată diverge:
 *   1. ecranul „Cum se lucrează" — diagramele;
 *   2. banda „ești aici" de pe fiecare ecran care face parte dintr-un flux;
 *   3. gruparea barei de navigare.
 *
 * Textele se traduc la CITIRE (`fluxuri()`), nu la definirea hărții: o hartă de
 * literali s-ar evalua o dată, la încărcarea modulului, iar comutatorul de
 * limbă ar schimba tot ecranul în afară de asta.
 */

const DEFINITIE = [
  {
    cod: "reactiv",
    titlu: "Mentenanță corectivă",
    rezumat:
      "Clientul sesizează, noi răspundem în termenul promis. E fluxul pe care se măsoară SLA-ul și cel care produce cele mai multe fișe.",
    pasi: [
      {
        sectiune: "tichete", titlu: "Tichet",
        face: "Clientul sau dispecerul deschide sesizarea.",
        duce: "Obiectul afectat ales aici decide severitatea, deci coloana de SLA și termenele. Ceasul de reacție pornește la deschiderea CLIENTULUI, nu la preluarea noastră.",
      },
      {
        sectiune: "tichete", titlu: "Propunere de vizită",
        face: "Dispecerul propune ziua și omul; clientul acceptă sau refuză.",
        duce: "Acceptarea NAȘTE vizita, legată de tichet, în aceeași tranzacție. Un refuz pune ceasul de restaurare în pauză, cu motivul scris.",
      },
      {
        sectiune: "interventii", titlu: "Vizită",
        face: "Lucrarea programată la o adresă, cu un om sau o echipă.",
        duce: "Din vizită se deschide fișa. O vizită fără fișă e o promisiune, nu o lucrare.",
      },
      {
        sectiune: "interventii", titlu: "Fișa de intervenție",
        face: "Cinci pași: check-in, constatări, operații, materiale, închidere.",
        duce: "Validarea e singurul moment care atinge lumea din afara fișei: descarcă stocul, urcă echipamentele în parc, mută scadența, scade contorul de abonament, naște restanțele. Totul odată, sau deloc.",
      },
      {
        sectiune: "interventii", titlu: "Deviz și semnătură",
        face: "Prețurile se îngheață pe linii; clientul semnează procesul-verbal.",
        duce: "O fișă semnată nu se mai modifică — regula e impusă de baza de date, nu lăsată pe seama bunăvoinței. Corectura se face prin stornare și o fișă nouă.",
      },
      {
        sectiune: "facturare", titlu: "Predare la facturare",
        face: "Fișele semnate se strâng într-un lot și pleacă spre contabilitate.",
        duce: "O fișă poate intra într-un singur lot — chiar asta împiedică aceeași lucrare să ajungă pe două facturi.",
      },
    ],
    ramuri: [
      { sectiune: "garantii", text: "Dacă echipamentul e în garanție, lucrarea are total zero — dar a costat, și se vede în rentabilitate." },
      { sectiune: "consum", text: "Dacă e inclusă în abonament, se scade din contorul contractului." },
      { sectiune: "restante", text: "Ce n-a putut fi rezolvat devine restanță — o fișă nu se închide lăsând constatări în aer." },
      { sectiune: "oferte", text: "Dacă devizul trebuie aprobat înainte, pleacă o ofertă, iar ceasul de restaurare stă în pauză până la răspuns." },
    ],
  },
  {
    cod: "preventiv",
    titlu: "Mentenanță preventivă",
    rezumat:
      "Ce se face după calendar, nu după defect. Aici se vede dacă firma își respectă propriile promisiuni din contract.",
    pasi: [
      {
        sectiune: "clienti", titlu: "Contract",
        face: "Se declară regimul preventiv: cu abonament, doar corectiv, atâtea cicluri pe an — sau, asumat, deloc.",
        duce: "„Fără preventiv\" cere motiv, nume și dată. La un control, diferența dintre „clientul a refuzat\" și „am uitat noi\" e diferența dintre problema lui și a ta.",
      },
      {
        sectiune: "preventiv", titlu: "Plan de mentenanță",
        face: "Un sistem instalat, un șablon de checklist, o frecvență.",
        duce: "Planul calculează singur următoarea scadență. Aritmetica e pe LUNI, nu pe zile: „peste o lună\" de pe 31 ianuarie cade pe ultima zi a lui februarie.",
      },
      {
        sectiune: "preventiv", titlu: "Scadență și generare",
        face: "Planurile ajunse la termen produc vizite.",
        duce: "Un plan care are deja o vizită deschisă nu primește alta, nici dacă generatorul rulează de mai multe ori deodată.",
      },
      {
        sectiune: "interventii", titlu: "Checklist pe teren",
        face: "Rândurile șablonului, bifate la fața locului, cu măsurători și fotografii unde se cer.",
        duce: "Șablonul e VERSIONAT: unul deja rulat pe teren nu se mai editează, iar execuțiile rămân legate de versiunea cu care au fost făcute.",
      },
      {
        sectiune: "restante", titlu: "Ce a rămas nerezolvat",
        face: "Neconformitățile devin restanțe, cu scor care crește cu vechimea.",
        duce: "Nu există buton „las-o așa\": dacă fișa s-a închis, restanțele s-au scris.",
      },
    ],
    ramuri: [
      { sectiune: "conformitate", text: "Execuțiile de checklist sunt chiar dovezile din dosarul de conformitate." },
    ],
  },
  {
    cod: "comercial",
    titlu: "Ofertare",
    rezumat:
      "De la o cerere sau o constatare, până la un „da\" scris al clientului.",
    pasi: [
      {
        sectiune: "oferte", titlu: "Ciornă",
        face: "Liniile se aleg din bibliotecă și din catalog, nu se scriu de mână.",
        duce: "O ofertă goală nu se poate trimite.",
      },
      {
        sectiune: "oferte", titlu: "Trimitere",
        face: "Prețurile se calculează și se îngheață; se emite linkul de acceptare.",
        duce: "Prețul se rezolvă în ordinea: lista clientului → prețul istoric la dată → catalog. Linkul se vede o singură dată; în bază rămâne doar amprenta lui.",
      },
      {
        sectiune: "oferte", titlu: "Decizia clientului",
        face: "Clientul deschide pagina publică, fără cont, și acceptă sau refuză cu motiv.",
        duce: "Decizia poartă dovada ei — nume, email, IP, moment — fiindcă nu există un cont în spate care s-o susțină.",
      },
      {
        sectiune: "interventii", titlu: "Lucrarea",
        face: "Oferta acceptată devine lucrare programată.",
        duce: "De aici încolo e chiar fluxul de mentenanță corectivă, de la vizită înainte.",
      },
    ],
    ramuri: [
      { sectiune: "catalog", text: "Prețurile de listă și cele negociate per client stau în catalog; oferta doar le citește." },
    ],
  },
  {
    cod: "parc",
    titlu: "Parc instalat și garanții",
    rezumat:
      "Evidența echipamentelor: de unde vin, cât sunt în garanție, ce documente au.",
    pasi: [
      {
        sectiune: "nomenclator", titlu: "Nomenclator",
        face: "Sisteme, subsisteme și tipuri de componentă — vocabularul comun.",
        duce: "Tipul de componentă poartă durata de viață și garanția standard, care ajung pe fiecare echipament montat.",
      },
      {
        sectiune: "parc", titlu: "Parc instalat",
        face: "Ce e montat, unde, din ce serie, de când.",
        duce: "Un echipament montat pe o fișă intră aici singur, cu garanția calculată din catalog. Istoricul lui se adaugă, nu se rescrie.",
      },
      {
        sectiune: "garantii", titlu: "Garanții",
        face: "Perioade cu istoric: cine o acordă, ce document o probează.",
        duce: "Tichetul deschis pe un echipament în garanție arată pe loc acoperirea — deci se știe ÎNAINTE de intervenție că lucrarea nu se plătește.",
      },
      {
        sectiune: "garantii", titlu: "Retur la furnizor",
        face: "Piesa defectă pleacă, vine alta în loc.",
        duce: "Registrul de returi e negocierea firmei cu furnizorul ei — clientul nu-l vede.",
      },
      {
        sectiune: "documente", titlu: "Dosar tehnic",
        face: "Scheme, manuale, procese-verbale — versionate.",
        duce: "Ce e marcat vizibil clientului ajunge în portalul lui; restul rămâne intern.",
      },
    ],
    ramuri: [],
  },
  {
    cod: "materiale",
    titlu: "Stocuri",
    rezumat:
      "De la articolul din catalog până la piesa montată și scăzută din gestiune.",
    pasi: [
      {
        sectiune: "catalog", titlu: "Catalog de articole",
        face: "Consumabile, manoperă, servicii — cu preț de achiziție și de vânzare.",
        duce: "Articolul poartă cota de TVA și garanția standard; amândouă ajung pe linia de fișă.",
      },
      {
        sectiune: "stoc", titlu: "Gestiuni",
        face: "Depozit, mașină de tehnician, consignație la client.",
        duce: "Gestiunea de pe linia de fișă spune de unde pleacă piesa. Fără gestiune, piesa se consideră cumpărată pe loc.",
      },
      {
        sectiune: "stoc", titlu: "Recepție și transfer",
        face: "Intrările și mutările între gestiuni, cu cost mediu ponderat.",
        duce: "Mișcările se adaugă, nu se rescriu: suma lor E soldul, nu o cifră ținută separat.",
      },
      {
        sectiune: "interventii", titlu: "Consum pe fișă",
        face: "Piesele trecute pe lucrare.",
        duce: "Stocul se descarcă abia la VALIDAREA fișei, nu când se scrie linia. Stornarea îl restituie.",
      },
      {
        sectiune: "stoc", titlu: "Inventar",
        face: "Se numără, se compară, se validează.",
        duce: "Inventarul nu editează soldul: scrie mișcări care îl aduc la cantitatea numărată.",
      },
    ],
    ramuri: [],
  },
  {
    cod: "masuram",
    titlu: "Analiză și conformitate",
    rezumat:
      "Ce iese din tot ce s-a lucrat: cifre pentru firmă și dosare pentru controale.",
    pasi: [
      {
        sectiune: "rapoarte", titlu: "Rapoarte",
        face: "SLA, timpi, fiabilitate, rentabilitate, consum, productivitate.",
        duce: "Niciun raport nu se materializează: totul se calculează la citire, deci nu poate rămâne în urmă după o stornare.",
      },
      {
        sectiune: "rapoarte", titlu: "Tablou de bord",
        face: "Cifrele zilei, adunate la un loc.",
        duce: "Tabloul CHEAMĂ rapoartele, nu le recalculează — altfel ar ajunge într-o zi să spună altceva decât raportul de sub el.",
      },
      {
        sectiune: "abateri", titlu: "Estimat vs. realizat",
        face: "Normele de timp livrate se corectează din munca reală.",
        duce: "Mediana, nu media — o zi proastă n-are voie să mute norma. Propunerea NU se aplică singură: o acceptă un om.",
      },
      {
        sectiune: "conformitate", titlu: "Registrul de conformitate",
        face: "Ce trebuie ținut la zi la fiecare client, cu ce dovadă.",
        duce: "Dosarul predat e înghețat și poartă o amprentă care se schimbă la orice modificare. Ce nu se poate proba automat se scrie ca atare — un dosar care tace unde nu știe e mai periculos decât unul care spune unde să te uiți.",
      },
      {
        sectiune: "jurnal", titlu: "Jurnal de audit",
        face: "Cine, ce, când — se adaugă, nu se rescrie, iar regula e impusă de baza de date.",
        duce: "Nici măcar codul aplicației nu poate rescrie istoricul.",
      },
    ],
    ramuri: [],
  },
];

/** Fluxurile, cu textele traduse la momentul citirii. */
export function fluxuri() {
  return DEFINITIE.map((f) => ({
    ...f,
    titlu: tr(f.titlu),
    rezumat: tr(f.rezumat),
    pasi: f.pasi.map((p) => ({ ...p, titlu: tr(p.titlu), face: tr(p.face), duce: tr(p.duce) })),
    ramuri: f.ramuri.map((r) => ({ ...r, text: tr(r.text) })),
  }));
}

/**
 * Fluxurile din care face parte o secțiune, cu poziția ei în fiecare.
 * O secțiune poate apărea în mai multe fluxuri (Intervenții e în patru) și de
 * mai multe ori în același — de-aia se întorc toate pozițiile, nu una.
 */
export function fluxurilePentru(codSectiune) {
  return fluxuri()
    .map((f) => {
      const pozitii = f.pasi
        .map((p, i) => (p.sectiune === codSectiune ? i : -1))
        .filter((i) => i >= 0);
      return pozitii.length ? { flux: f, pozitii } : null;
    })
    .filter(Boolean);
}
